import { useState, useEffect } from 'react';
import AgoraRTC from '../utils/AgoraEnhancer';

const noop = () => {};

const useMicrophone = () => {
  const [microphoneList, setMicrophoneList] = useState([]);

  useEffect(() => {
    let mounted = true;

    const updateMicrophoneList = async () => {
      try {
        // SDK v4 usa método estático
        const microphones = await AgoraRTC.getMicrophones();
        if (mounted) {
          setMicrophoneList(microphones);
        }
      } catch (err) {
        console.error('Error getting microphones:', err);
      }
    };

    // SDK v4 usa evento microphoneChanged
    const handleDeviceChange = () => {
      updateMicrophoneList();
    };

    // Listener para mudanças de dispositivo
    AgoraRTC.onMicrophoneChanged = handleDeviceChange;

    // Carrega lista inicial
    updateMicrophoneList();

    return () => {
      mounted = false;
      AgoraRTC.onMicrophoneChanged = undefined;
    };
  }, []);

  return microphoneList;
};

export default useMicrophone;
